import { useTranslation, useWithdrawForm } from '@starsoft/common/hooks';
import { useFormContext } from 'react-hook-form';
import { WithdrawFormCreateDto } from '../../../../../../../../dto/withdrawals/baseWithdrawalInputDto/withdraw-create-form.dto';
import TransactionMethods from '../../../../../../Common/Content/TransactionMethods';

/**
 * WithdrawalMethods Component
 * This component is responsible for rendering the available withdrawal methods in the form.
 *
 * @returns {JSX.Element} The TransactionMethods component with the withdrawal methods.
 *
 * @example
 * // Usage example:
 * <WithdrawalMethods />
 */
export default function WithdrawalMethods() {
  // Retrieve the translation function for the 'withdraw' namespace
  const { t } = useTranslation('withdraw');
  // Retrieve form context methods for watching and setting form values
  const { watch, setValue } = useFormContext<WithdrawFormCreateDto>();
  // Use custom hook to manage withdrawal form state and methods
  const {
    isFormLoading,
    withdrawMethodsQuery: { withdrawMethods },
  } = useWithdrawForm(watch, setValue);

  // Render the TransactionMethods component with the withdrawal methods
  return (
    <TransactionMethods
      isLoading={isFormLoading}
      label={t('withdrawal_method')}
      transactionMethods={withdrawMethods}
    />
  );
}
